import React, { PureComponent } from 'react';
import {
  Container,
  AdContainer,
  AdWrapper,
  CardContainer,
  BoughtContentsCardWrapper,
  LoadingWrapper,
} from './elements';
import { LoadingIndicator } from '../../atoms/LoadingIndicator';
import { ProfileCard } from '../../molecules/ProfileCard';
import { PointsHeldCard } from '../../molecules/PointsHeldCard';
import { PurchasePointsCard } from '../../molecules/PurchasePointsCard';
import { BoughtContentsCard } from '../../molecules/BoughtContentsCard';
import { Advertisement } from '../../atoms/Advertisement';
import { ProfileCardParams } from './types';
import { AdvertisementModel } from '../../../domain/entities';

type Props = {
  profileCard: ProfileCardParams;
  points: number;
  linkForPurchasing: string;
  ads?: Array<AdvertisementModel>;
  isFetchingAds: boolean;
};

class RightSidebar extends PureComponent<Props> {
  static defaultProps = {
    profileCard: { percentage: 0 },
  };

  render = (): React.ReactElement => {
    const {
      profileCard,
      points,
      ads,
      linkForPurchasing,
      isFetchingAds,
    } = this.props;

    return (
      <Container>
        <ProfileCard
          name={profileCard.name}
          rank={profileCard.rank}
          percentage={profileCard.percentage}
          pointsNeeded={profileCard.pointsNeeded}
        />
        <CardContainer>
          <PointsHeldCard points={points} />
          <PurchasePointsCard
            id="home-purchasePointsCard"
            link={linkForPurchasing}
          />
        </CardContainer>
        <BoughtContentsCardWrapper data-cy="home-purchasesCard">
          <BoughtContentsCard />
        </BoughtContentsCardWrapper>
        <AdContainer>
          {isFetchingAds ? (
            <LoadingWrapper>
              <LoadingIndicator />
            </LoadingWrapper>
          ) : (
            <>
              {ads && ads.length > 0
                ? ads.map(ad => (
                    <AdWrapper key={ad.imageUrl}>
                      <Advertisement {...ad} />
                    </AdWrapper>
                  ))
                : null}
            </>
          )}
        </AdContainer>
      </Container>
    );
  };
}

export default RightSidebar;
